var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{ref:"input",attrs:{"type":"checkbox"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }